import type { ReactNode } from 'react';

import { Flex } from '@rover/kibble/core';
import { isReactNative } from '@rover/rsdk/src/modules/Network/userAgent';

import type { GalleryItem, PaginationConfig } from './ImageGallery.common';
import ImageGridCloseButton from './ImageGridCloseButton';
import ImageGridContainer from './ImageGridContainer';

type ImageGridProps = {
  images: GalleryItem[] | undefined;
  onClose: () => void;
  onImageClick: (index: number) => void;
  pagination?: PaginationConfig;
  renderImageOverlay?: (index: number) => ReactNode;
};

const ImageGrid = ({
  images,
  onClose,
  onImageClick,
  pagination,
  renderImageOverlay,
}: ImageGridProps): JSX.Element => {
  return (
    <Flex flexDirection="column" flex="1" width="100%" justifyContent="center" gap="6x">
      {!isReactNative() && <ImageGridCloseButton onClick={onClose} />}
      {images && (
        <ImageGridContainer
          images={images}
          onImageClick={onImageClick}
          onClose={onClose}
          pagination={pagination}
          renderImageOverlay={renderImageOverlay}
        />
      )}
    </Flex>
  );
};

export default ImageGrid;
